// useAgentGlue.ts
import { useState, useCallback } from "react";
import { runAgent } from "@aiux/agent/agent";
import retrieve_sales_forecast from "@aiux/agent/tools/retrieve_sales_forecast";
import retrieve_sales_goals from "@aiux/agent/tools/retrieve_sales_goals";
import retrieve_sales_actuals from "@aiux/agent/tools/retrieve_sales_actuals";

const SYSTEM_PROMPT = `You are a helpful assistant in FFP Area. You help the user to get insights about
- Sales actuals
- Sales forecast
- Sales goals
- Information about units

You DO NOT ANSWER ANY QUESTIONS OUTSIDE OF THE SCOPE.
If the user is asking questions outside of the scope, you should let the user know that you can't help with that.
Instead ask following questions to collect information to better understand the user's intent
for using your tools to answer with the right information. Do not answer questions about personal matters or anything out of scope.

Today's date is 2025-03-05`;

export function useAgentGlue() {
  const [messages, setMessages] = useState<{ role: string; content: string }[]>([]);
  const [isThinking, setIsThinking] = useState(false);
  const [thinkingMessage, setThinkingMessage] = useState("Thinking...");

  const submitPrompt = useCallback(async (message: string) => {
    if (!message) return;

    // Add user message
    const newMessages = [...messages, { role: "user", content: message }];
    setMessages(newMessages);
    setThinkingMessage("Thinking...");
    setIsThinking(true);

    try {
      const response = await runAgent({
        system: SYSTEM_PROMPT,
        messages: newMessages as any,
        tools: {
          retrieve_sales_forecast,
          retrieve_sales_goals,
          retrieve_sales_actuals,
        },
      });

      setMessages([...newMessages, { role: "assistant", content: response.text }]);
    } catch (error) {
      console.log({error})
      setMessages([
        ...newMessages,
        {
          role: "assistant",
          content: "Sorry, there was an error processing your request.",
        },
      ]);
    } finally {
      setIsThinking(false);
    }
  }, [messages]);

  return {
    messages,
    isThinking,
    thinkingMessage,
    submitPrompt,
  };
}